import getRequest from '../get'
import queryBuilder from '../../../helpers/queryBuilder'
import { ImageQualityCheck, KTPOCR } from '../../endpoint/ocr'

export const getKTPOCR = async ({ query }) => {
  const queryString = queryBuilder(query)
  try {
    const url = `${KTPOCR}${queryString}`
    const result = await getRequest(url)
    return result
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside the 2xx range
      return error.response
    } else {
      // Something else went wrong (e.g., network error)
      console.error('Unexpected error:', error)
      return error
    }
  }
}

export const getImageQualityCheck = async ({ query }) => {
  const queryString = queryBuilder(query)
  try {
    const url = `${ImageQualityCheck}${queryString}`
    const result = await getRequest(url)
    return result
  } catch (error) {
    if (error.response) {
      // Server responded with a status outside the 2xx range
      return error.response
    } else {
      // Something else went wrong (e.g., network error)
      console.error('Unexpected error:', error)
      return error
    }
  }
}
